import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungRemscheid() {
  return (
    <CityPageTemplate
      city="Remscheid"
      slug="remscheid"
      intro="Remscheid im Bergischen Land – unabhängige Finanzberatung ohne versteckte Kosten."
      description="Unabhängige & digitale Finanzberatung für Remscheid: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
